import { Modal } from "antd";
import Loading from "components/Loading";
import { ENTERED_FROM_LOGIN } from "constants/auth";
import usePermisos from "hooks/usePermisos";
import { Suspense, lazy } from "react";
import { Navigate, Outlet, createBrowserRouter, useLocation } from "react-router-dom";
import Tramos from "routes/lineas/Tramos";
import AumentoPrecios from "routes/preciosV2/AumentoPrecios";
import AppLayout from "./components/Layout/AppLayout";
import NotFound from "./components/NotFound";

const LoginPage = lazy(() => import("./routes/login"));
const NoLogin = lazy(() => import("./routes/clientes/Nuevo/NoLogin"));
const InicioPage = lazy(() => import("./routes/inicio"));
const Configuracion = lazy(() => import("./routes/configuracion"));
const ClientesPage = lazy(() => import("./routes/clientes"));
const ClientesEditarPage = lazy(() => import("./routes/clientes/Editar"));
const UsuariosPage = lazy(() => import("./routes/usuarios"));
const FilialesPage = lazy(() => import("./routes/filiales"));
const FilialesEditarPage = lazy(() => import("./routes/filialesEditar"));
const LocalidadesPage = lazy(() => import("./routes/localidades"));
const RolesPage = lazy(() => import("./routes/roles"));
const ArticulosPage = lazy(() => import("./routes/articulos"));
const ContratistasPage = lazy(() => import("./routes/contratistas"));
const VehiculosPage = lazy(() => import("./routes/vehiculos"));
const VehiculosTiposPage = lazy(() => import("./routes/vehiculosTipos"));
const SubrubrosPage = lazy(() => import("./routes/subrubros"));
const AcuerdosPage = lazy(() => import("./routes/acuerdos"));
const RedespachantesPage = lazy(() => import("./routes/redespachantes"));
const RedespachantesPreciosPage = lazy(() => import("./routes/redespachantes/RedespachantesPrecios"));
const RedespachantesPrecioDetallePageOLD = lazy(() => import("./routes/redespachantesPrecioDetalle-old"));
const DocumentosPage = lazy(() => import("./routes/documentos"));
const DocumentoDetallePage = lazy(() => import("./routes/documentos/Editar"));
const DocumentacionFilialesPage = lazy(() => import("./routes/documentacionFiliales"));
const PreciosPage = lazy(() => import("./routes/precios"));
const PreciosEditarPage = lazy(() => import("./routes/precios/Editar"));
const PreciosV2Page = lazy(() => import("./routes/preciosV2"));
const PreciosV2EditarPage = lazy(() => import("./routes/preciosV2/Editar"));
const TramosPage = lazy(() => import("./routes/tramos"));
const ComprobantesPage = lazy(() => import("./routes/comprobantes"));
const AutorizacionesPage = lazy(() => import("./routes/autorizaciones"));
const ContenedoresPage = lazy(() => import("./routes/contenedores"));
const LecturasPage = lazy(() => import("./routes/lecturas"));
const LecturasDetallePage = lazy(() => import("./routes/lecturas/Detalle"));
const DistribuidoresPage = lazy(() => import("./routes/distribuidores"));
const VehiculosSalidasPage = lazy(() => import("./routes/vehiculosSalidas"));
const SeguimientoPage = lazy(() => import("./routes/seguimiento"));
const DepositosPage = lazy(() => import("./routes/depositos"));
const DistribucionesPage = lazy(() => import("./routes/distribuciones"));
const DistribucionesDetallePage = lazy(() => import("./routes/distribuciones/DetalleCorredor"));
const UltimaMillaDetallePage = lazy(() => import("./routes/distribuciones/DetalleUltimaMilla"));
const RendicionPage = lazy(() => import("./routes/distribuciones/Rendicion"));
const ProveedoresPage = lazy(() => import("./routes/proveedores"));
const LineasPage = lazy(() => import("./routes/lineas"));
const PedidosPage = lazy(() => import("./routes/pedidos"));
const PedidosNuevoPage = lazy(() => import("./routes/pedidos/components/Nuevo"));
const MaterialesPage = lazy(() => import("./routes/solicitudesV2/Materiales"));
const SiniestrosPage = lazy(() => import("./routes/solicitudesV2/Siniestros"));
const SolicitudesEditarPage = lazy(() => import("./routes/solicitudesV2/Editar"));
const SolicitudesNuevoPage = lazy(() => import("./routes/solicitudesV2/Nuevo"));
// const MaterialesPage = lazy(() => import("./routes/solicitudesV3/Materiales"));
// const SiniestrosPage = lazy(() => import("./routes/solicitudesV3/Siniestros"));
// const SolicitudesEditarPage = lazy(() => import("./routes/solicitudesV3/Editar"));
// const SolicitudesNuevoPage = lazy(() => import("./routes/solicitudesV3/Nuevo"));
const SolicitudesTiposPage = lazy(() => import("./routes/solicitudesTipos"));
const SolicitudesTiposEditarPage = lazy(() => import("./routes/solicitudesTipos/components/Editar"));
const NotFoundPage = lazy(() => import("./components/NotFound"));
const IndicesPage = lazy(() => import("./routes/indices"));
const CreditosPage = lazy(() => import("./routes/creditos"));
const DespachoCreditoPage = lazy(() => import("./routes/despachoCredito"));
const PlanesPage = lazy(() => import("./routes/planes"));
const AutomaticosPage = lazy(() => import("./routes/automaticos"));
const ConciliacionPage = lazy(() => import("./routes/conciliacion"));
const SaldoClientesPage = lazy(() => import("./routes/saldoClientes"));
const ResumenCuentasPage = lazy(() => import("./routes/resumenCuentas"));
const ComprobantesPendientesPage = lazy(() => import("./routes/comprobantesPendientes"));
const EnvasesPage = lazy(() => import("./routes/envases"));
const ResumenPrepagoPage = lazy(() => import("./routes/resumenPrepago"));
const CanalizadorPage = lazy(() => import("./routes/canalizador"));
const ExigenciasPage = lazy(() => import("./routes/exigencias"));
const IncumplimientosPage = lazy(() => import("./routes/incumplimientos"));
const FacturacionInteresesPage = lazy(() => import("./routes/facturacionIntereses"));
const AutorizacionesEnviosDetallePage = lazy(() => import("./routes/autorizaciones/components/Envios/Detalles"));
const AutorizacionesNcDetallePage = lazy(() => import("./routes/autorizaciones/components/NotasCreditos/Detalles"));
const AutorizacionesRefacturacionDetallePage = lazy(() => import("./routes/autorizaciones/components/Refacturacion/Detalles"));
const ComisionesPage = lazy(() => import("./routes/informesComision"));
const LiquidacionesPage = lazy(() => import("./routes/liquidaciones"));
const DevengadosPage = lazy(() => import("./routes/devengados"));
const IntersucursalesPage = lazy(() => import("./routes/intersucursales"));
const SaldoCajasPage = lazy(() => import("./routes/saldoCajas"));
const TransferenciasPage = lazy(() => import("./routes/transferencias"));
const RemitosPendientesPage = lazy(() => import("./routes/remitosPendientes"));
const AcuerdosRedespachosPage = lazy(() => import("./routes/acuerdosRedespachos"));
const RemitosConformadosPage = lazy(() => import("./routes/remitosConformados"));
const RemitosConformadosDetallePage = lazy(() => import("./routes/remitosConformados/Recibir/Detalle"));
const StockPage = lazy(() => import("./routes/stock"));
const GrandesClientePage = lazy(() => import("./routes/grandesClientes"));
const VerCajaPage = lazy(() => import("./routes/verCajas"));
const DespachoPickUpPage = lazy(() => import("./routes/despachoPickUp"))
const ResumenFacturasPage = lazy(() => import("./routes/resumenFacturas"))
const ReportesPage = lazy(() => import("./routes/reportes"))

const ProtectedRoute = ({ children }) => {
  const enteredFromLogin = localStorage.getItem(ENTERED_FROM_LOGIN) === 'true';
  const location = useLocation();
  const permisos = usePermisos("view", location.pathname);

  if (!enteredFromLogin) {
    return <Navigate to="/login" />;
  }

  if (!permisos.consulta) {
    Modal.error({
      title: "Error",
      content: "No estas autorizado a ver esta vista.",
      okText: "OK",
      maskClosable: false,
      keyboard: false,
      closable: false,
    });
    return <Navigate to="/" />;
  }

  return children;
};

const router = createBrowserRouter([
  {
    path: "/login",
    element: (
      <Suspense fallback={<Loading fullscreen />}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: "/clientes/embed/:auth0Id",
    element: <NoLogin />,
  },
  {
    path: "/usuario/:ualta/clientes/nuevo",
    element: <NoLogin />,
  },
  {
    path: "/usuario/:ualta/clientes/:clientes_id_speed/domicilio/nuevo",
    element: <NoLogin />,
  },
  {
    path: "/clientes/nuevo/:tokenParam",
    element: <NoLogin />,
  },
  {
    path: "/clientes/:id/domicilio/nuevo/:tokenParam",
    element: <NoLogin />,
  },
  {
    path: "/clientes/:id/domicilio/entrega/nuevo/:tokenParam",
    element: <NoLogin />,
  },
  {
    path: "/clientes/:id/domicilio/entrega/retiro/nuevo/:tokenParam",
    element: <NoLogin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    element: (
      <AppLayout>
        <Outlet />
      </AppLayout>
    ),
    children: [
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              {/* <InicioPage /> */}
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <InicioPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/configuracion",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <Configuracion />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/clientes",
        element: (
          <ProtectedRoute vista="Clientes">
            <Suspense fallback={<Loading fullscreen />}>
              <ClientesPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/clientes/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ClientesEditarPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/usuarios",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <UsuariosPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/filiales",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <FilialesPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/filiales/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <FilialesEditarPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/localidades",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <LocalidadesPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/roles",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <RolesPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/articulos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ArticulosPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/contratistas",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ContratistasPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/vehiculos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <VehiculosPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/vehiculostipos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <VehiculosTiposPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/subrubros",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SubrubrosPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/acuerdos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <AcuerdosPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/acuerdos/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <PreciosV2EditarPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/acuerdosV2/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <PreciosV2EditarPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/redespachantes",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <RedespachantesPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/redespachantes/:id/precios",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <RedespachantesPreciosPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/redespachantes/:id/precios/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              {/* <RedespachantesPrecioDetallePage /> */}
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/redespachantes/:idredespachante/precios/:idredespachantespreciosold",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <RedespachantesPrecioDetallePageOLD />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/acuerdos-redespachos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <AcuerdosRedespachosPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/documentos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DocumentosPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/documentos/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DocumentoDetallePage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/precios",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <PreciosV2Page />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/precios/aumentos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <AumentoPrecios />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/precios/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <PreciosV2EditarPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/filiales/documentacion",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DocumentacionFilialesPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/tramos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <TramosPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/comprobantes",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ComprobantesPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/autorizaciones",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <AutorizacionesPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/contenedores/canastos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ContenedoresPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/contenedores/bolsines",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ContenedoresPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/contenedores/colectoras",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ContenedoresPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/lecturas",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <LecturasPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/lecturas/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <LecturasDetallePage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/distribuidores",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DistribuidoresPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/vehiculos/salidas",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <VehiculosSalidasPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/seguimiento",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SeguimientoPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/depositos",
        element: (
          <ProtectedRoute fallback={<Loading fullscreen />}>
            <Suspense>
              <DepositosPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/troncal",
        element: (
          <ProtectedRoute fallback={<Loading fullscreen />}>
            <Suspense>
              <DistribucionesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/troncal/:accion",
        element: (
          <ProtectedRoute fallback={<Loading fullscreen />}>
            <Suspense>
              <DistribucionesDetallePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/lateral",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DistribucionesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/lateral/:accion",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DistribucionesDetallePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/entrega",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DistribucionesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/entrega/:accion",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DistribucionesDetallePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/despacho",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DistribucionesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/despacho/:accion",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DistribucionesDetallePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/ultimamilla",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DistribucionesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/ultimamilla/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <UltimaMillaDetallePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/rendicion",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <RendicionPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/proveedores",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ProveedoresPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/lineas",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <LineasPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/lineas/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <Tramos />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/pedidos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <PedidosPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/pedidos/:accion",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <PedidosNuevoPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/solicitudes/detalles/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SolicitudesEditarPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/nueva/solicitud/materiales",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SolicitudesNuevoPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/nueva/solicitud/siniestros",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SolicitudesNuevoPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/solicitudes/materiales",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <MaterialesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/solicitudes/siniestros",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SiniestrosPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/solicitudes/tipos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SolicitudesTiposPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/solicitudes/tipos/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SolicitudesTiposEditarPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/prepagos/venta",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <CreditosPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/indices",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <IndicesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/prepagos/despacho",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DespachoCreditoPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/not-found",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <NotFoundPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/planes",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <PlanesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/automaticos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <AutomaticosPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/conciliacion",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ConciliacionPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/saldo/clientes/automaticos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SaldoClientesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/saldo/clientes",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SaldoClientesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/cuentas/resumen",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ResumenCuentasPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/comprobantes/pendientes",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ComprobantesPendientesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/envases",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <EnvasesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/prepagos/resumen",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ResumenPrepagoPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/canalizador",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <CanalizadorPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/exigencias",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ExigenciasPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/incumplimientos",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <IncumplimientosPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/intereses/facturacion",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <FacturacionInteresesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/cajas/visualizar",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <VerCajaPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/cajas/visualizar/:idcaja",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <VerCajaPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/autorizaciones/envios/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <AutorizacionesEnviosDetallePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/autorizaciones/nc/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <AutorizacionesNcDetallePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/autorizaciones/refacturacion/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <AutorizacionesRefacturacionDetallePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/comisiones/informe",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ComisionesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/comisiones/devengado",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DevengadosPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/comisiones/liquidacion",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <LiquidacionesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/intersucursal",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <IntersucursalesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/saldo/cajas",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <SaldoCajasPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/transferencias",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <TransferenciasPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/remitos/pendientes",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <RemitosPendientesPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/remitos-conformados",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <RemitosConformadosPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/remitos-conformados/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <RemitosConformadosDetallePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/stock",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <StockPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/guias",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <GrandesClientePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/guias/registrar",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <GrandesClientePage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/despacho/pickup",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <DespachoPickUpPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/resumen/facturas",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ResumenFacturasPage />
            </Suspense>
          </ProtectedRoute>
        )
      },
      {
        path: "/reportes",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loading fullscreen />}>
              <ReportesPage />
            </Suspense>
          </ProtectedRoute>
        )
      }
    ],
  },
]);

export default router;

